import {UNCOVERING, UNCOVERED, VOTED_BACK} from '../actions/votes'

function getValentineIndex(list, id) {
  for (let i=0; i<list.length; i++) {
    if (list[i].hiddenId == id) return i
  }
  return -1
}

function latestVotes(state = {}, action = {}) {
  switch(action.type) {
    case UNCOVERED:

      var index = getValentineIndex(state, action.valentine.hiddenId)

      return index > -1 ? [
        ...state.slice(0, index),
        action.valentine,
        ...state.slice(index + 1)
      ] : state
    case VOTED_BACK:
      var index = getValentineIndex(state, action.valentine.hiddenId)

      return index > -1 ? [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ] : state
    default:
      return state
  }
}

function myVotes(state = {}, action = {}) {
  switch (action.type) {
    default:
      return state
  }
}

function mutualVotes(state = {}, action = {}) {
  switch (action.type) {
    default:
      return state
  }
}

function votes(state = {}, action = {}) {
  switch (action.type) {
      case UNCOVERING:
          var index = getValentineIndex(state.hidden.votes, action.hiddenId)
      return {
        ...state,
          hidden: {
              count: state.hidden.count,
              votes: [
                ...state.hidden.votes.slice(0, index),
                { ...state.hidden.votes[index], loading: true },
                ...state.hidden.votes.slice(index + 1)
              ]
          },
      }
    case UNCOVERED:

      var index = getValentineIndex(state.hidden.votes, action.valentine.hiddenId)

      const newState = index > -1 ? {
        ...state,
          hidden: {
              count: state.hidden.count,
              votes: [
                ...state.hidden.votes.slice(0, index),
                action.valentine,
                ...state.hidden.votes.slice(index + 1)
              ]
          },
      } : state

      return newState
    case VOTED_BACK:

          var hiddenIndex = getValentineIndex(state.hidden.votes, action.valentine.hiddenId)
          var visibleIndex = getValentineIndex(state.visible.votes, action.valentine.hiddenId)

      if (hiddenIndex > -1) {
        return {
          ...state,
            hidden: {
                count: state.hidden.count,
                votes: [
                  ...state.hidden.votes.slice(0, hiddenIndex),
                  ...state.hidden.votes.slice(hiddenIndex + 1)
                ]
            },
        }
      }

      if (visibleIndex > -1) {
          return {
              ...state,
              visible: {
                  count: state.visible.count,
                  votes: [
                      ...state.visible.votes.slice(0, visibleIndex),
                      ...state.visible.votes.slice(visibleIndex + 1)
                  ]
              }
          }
      }

      return state
    default:
      return state
  }
}

export default function allVotes(state = {}, action = {}) {
  switch (action.type) {
    default:
      return {
        latest: latestVotes(state.latest, action),
        my: myVotes(state.my, action),
        mutual: mutualVotes(state.mutual, action),
        votes: votes(state.votes, action)
      }
  }
}

